import React from 'react'

import { usd } from 'src/components/I18n'
import InfoPopover from './InfoPopover'

// Shown on the Start step in PageHeader's `slot` when the fundraiser
// has an active match — replaces the static subtitle when one is
// present (bossman copy direction: drop subtitles, surface the match
// message in that slot on Page 1).
//
// Renders as a small subtitle-style line with three pieces:
//   - badge — short "2x" pill in brand colors, set off from the text
//   - message — "%{org} is matching your gift!" with the partner's
//     name substituted via matching.subject
//   - tooltip — cap + end-date detail in the info popover. Cap maps
//     to matching.user_limit (per-donor) when present, else
//     matching.overall_limit; formatted as USD because match limits
//     are stored in USD regardless of the donor's selected currency.
const MatchingBanner = ({ i18n, matching }) => {
  const cap = matching.user_limit || matching.overall_limit
  // Pick the tooltip variant by which fields are present — the cap/date
  // template phrases would otherwise read awkwardly when their value is
  // empty ("Gifts are being matched up to  through DATE.").
  const tooltipKey =
    cap && matching.end_date ? 'matching.tooltip' :
    cap                      ? 'matching.tooltip_no_date' :
    matching.end_date        ? 'matching.tooltip_no_cap' :
                               'matching.tooltip_no_cap_no_date'
  const tooltip = i18n.t(tooltipKey, {
    match_cap: cap ? i18n.formatCurrency(cap, usd) : '',
    match_date: matching.end_date || '',
  })

  // div, not p — InfoPopover mounts an absolutely-positioned panel
  // <div>, invalid phrasing content inside a <p> (dev-only
  // validateDOMNesting warning). Tailwind preflight zeroes margins, so
  // there's no visual difference.
  return (
    <div className="text-sm text-gray-500">
      <span className="me-1 inline-flex items-center rounded-full bg-brand-100 text-brand-700 px-1.5 py-0.5 text-xs font-semibold">
        {i18n.t('matching.badge')}
      </span>
      {i18n.t('matching.message', { org: matching.subject })}
      {' '}
      <InfoPopover label={i18n.t('learn_more')} boundary=".widget-content">
        {tooltip}
      </InfoPopover>
    </div>
  )
}

export default MatchingBanner
